import { Inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { IWidget } from "../../../../models/application/i-widget";
import { widgetRestClientInjectionToken } from "../../../../rest-clients/application/widget/widget-rest-client-injection-token";
import { IWidgetRestClient } from "../../../../rest-clients/application/widget/i-widget-rest.client";

@Injectable()
export class WidgetResolver implements Resolve<IWidget> {
  constructor(@Inject( widgetRestClientInjectionToken ) private readonly _widgetRestClient: IWidgetRestClient) {
  }

  resolve(route: ActivatedRouteSnapshot): Promise<IWidget> {
    const widgetId: string | null = route.paramMap.get( 'widgetId' );

    if ( widgetId === null ) {
      return Promise.reject();
    }

    return this._widgetRestClient.getApplication( {
      recordId: widgetId
    } )
  }
}
